// Chain references (blocks, transactions, UTxOs, addresses) open on AdaStat; tokens open on
// Cardanoscan instead. [[knowledge-explorer-links]]
const ADASTAT = "https://adastat.net";

const adaStatBlock = (blockId: string) => `${ADASTAT}/blocks/${blockId}`;

/** AdaStat pages a transaction, not one of its outputs, so the output index is dropped. */
const adaStatTransaction = (txId: string) => `${ADASTAT}/transactions/${txId}`;

const adaStatAddress = (address: string) => `${ADASTAT}/addresses/${address}`;

const URLS = {
    block: adaStatBlock,
    transaction: adaStatTransaction,
    utxo: (reference: string) => adaStatTransaction(reference.split("#")[0]!),
    address: adaStatAddress,
};

export type ChainReference = keyof typeof URLS;

export const adaStatUrl = (kind: ChainReference, value: string) => URLS[kind](value);
